import {Component, OnInit, OnDestroy} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';
import {VehicleService} from 'services/calculator-items/vehicle.service';
import {EmissionService} from 'services/emission.service';
import {FooterNavbarService} from 'services/connectors/footer-navbar.service';
import {SpinnerService} from 'services/spinner.service';
import {CustomValidators} from 'ng2-validation';

@Component({
    selector: 'tpc-boat',
    templateUrl: './boat.component.html',
    styleUrls: ['./boat.component.css']
})
export class BoatComponent implements OnInit, OnDestroy {
    private nextSub: Subscription;
    private isFormSubmitted = false;

    public boatForm: FormGroup;
    public fuelTypeList = [
        {key: 'gasoline', value: 'Gasoline'},
        {key: 'diesel', value: 'Diesel'},
        {key: 'bioDieselB20', value: 'Biodiesel (B20)'},
        {key: 'bioDieselB100', value: 'Biodiesel (B100)'},
        {key: 'cng', value: 'Compressed Natural Gas'},
        {key: 'ethanol', value: 'Ethanol'},
    ];

    private fuelTypeDisplayNames = {
        gasoline: 'Gasoline',
        diesel: 'Diesel',
        bioDieselB20: 'Biodiesel B20',
        bioDieselB100: 'Biodiesel B100',
        cng: 'CNG',
        ethanol: 'Ethanol'
    };

    constructor(private emissionService: EmissionService,
                private vehicleService: VehicleService,
                private footerService: FooterNavbarService,
                private router: Router,
                private fb: FormBuilder,
                private spinner: SpinnerService
    ) {
        this.nextSub = footerService.next$.subscribe(() => {
            this.isFormSubmitted = true;
            if (this.boatForm.status === 'VALID') {
                this.next();
            }
        });
        this.createForm();
    }

    ngOnInit() {
    }

    private createForm() {
        this.boatForm = this.fb.group({
            gallon: [1, [
                Validators.required,
                CustomValidators.min(1),
                CustomValidators.max(9999999),
                CustomValidators.digits]],
            fuelType: ['gasoline', Validators.required ]
        });
    }

    private next() {
        let params = {
            VEHICLETYPE: 'boat',
            GALLON: this.getFV('gallon'),
            FUELTYPE: this.getFV('fuelType'),
        };

        this.spinner.show();
        this.emissionService.getEmissionValue(params).subscribe(
            response => {
                let input = response.body[0].input[0];
                this.vehicleService.addToVehicleList({
                    title: this.getTitleForVehicleList(),
                    emission: input.emmission,
                    emissionTrees: input.emissionTrees,
                    DollarAmt: input.DollarAmt,
                    DollarAmtMonthly: input.DollarAmtMonthly
                });

                this.router.navigate(['/individual/vehicle/list']);
                this.spinner.hide();
            }
        );
    }

    private getTitleForVehicleList() {
        return `Boat, ${this.getFV('gallon')} gallons of ${this.fuelTypeDisplayNames[this.getFV('fuelType')]}`;
    }


    checkError(param) {
        return this.boatForm.get(param).status === 'INVALID' && (this.isFormSubmitted || this.boatForm.get(param).touched);
    }

    getFV(param) {
        return this.boatForm.get(param).value;
    }

    ngOnDestroy () {
        if (this.nextSub) {
            this.nextSub.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/shared/main/vehicle/boat/boat.component.ts